/**
 * Created by vhe on 3/2/2017.
 */
'use strict';
import angular from 'angular';
import quickViewController from './quickView.controller';
var ProductCardController = /** @class */ (function () {
    /*@ngInject*/
    function ProductCardController(CartService, $scope, $mdDialog, $location, ProductService, $filter, CommonDataService, googleAnalytic, $rootScope, $window, warehouseService) {
        var _this = this;
        this.searchText = '';
        this.scope = '';
        this.displayPopup = false;
        this.multipleOf = false;
        this.oldPurchaseQuantity = 1;
        this.hasCondition = false;
        this.selectedItem = null;
        this.selectedItemInventory = null;
        this.expectedDeliverDate = '';
        this.totalStock = 0;
        var self = this;
        this.$mdDialog = $mdDialog;
        this.scope = $scope;
        this.rootScope = $rootScope;
        this.productService = ProductService;
        this.cart = CartService;
        this.CommonDataService = CommonDataService;
        this.CommonDataService.addAttributeProductPathsForSingleItem(self.config);
        this.product = self.config;
        this.$filter = $filter;
        this.$window = $window;
        var date = new Date();
        this.currentDate = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + 'T' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        this.$scope = $scope;
        $scope.ga = googleAnalytic;
        $scope.purchaseQuantity = 1;
        this.WarehouseService = warehouseService;
        // $scope.inventory = {};
        /*this.outOfStockMessage = */
        //if there is unique search term, check if it match the itemCode and set up the dropdown index
        // $scope.selectItemNum = 0;
        var isTemporaryHeatSensitiveItem = function () {
            var dateNow = new Date();
            var from_date = Date.parse(new Date(dateNow.getFullYear(), 3, 1)); // the month is 0-based
            var to_date = Date.parse(new Date(dateNow.getFullYear(), 8, 30)); // the month is 0-based
            var today = Date.parse(dateNow);
            if (today > from_date && today < to_date) {
                return true;
            }
            else {
                return false;
            }
        };
        $scope.addingToCart = null;
        $scope.addToCartResponse = null;
        this.addingToCartDialog = {
            template: "\n        <md-dialog class=\"cart-summary-dialog\">\n          <cart-summary-dialog adding-to-cart=\"addingToCart\"\n                               item=\"item\"\n                               response=\"addToCartResponse\"\n                               quantity=\"purchaseQuantity\"\n                               limited-stock=\"limitedStock\"></cart-summary-dialog>\n        </md-dialog>\n      ",
            scope: $scope,
            preserveScope: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false
        };
        this.addToCart = function (item, quantity) {
            if (!quantity) {
                return false;
            }
            $scope.addingToCart = _this.cart.addItemQuantity(item.itemCode, quantity)
                .then(function (data) {
                $scope.addToCartResponse = data;
            })
                .catch(function (reason) {
                $scope.addToCartResponse = { error: true, reason: reason };
            })
                .finally(function () {
                $scope.addingToCart = null;
            });
        };
        this.onAddItemClick = function (item, quantity, form, ev) {
            item['brandName'] = _this.product.brandName;
            $scope.item = item;
            $scope.limitedStock = _this.selectedItem.isDiscontinued; //self.config.items[$scope.selectItemNum].isDiscontinued;
            _this.$mdDialog.show(Object.assign({
                targetEvent: ev,
                onShowing: function () {
                    $rootScope.saveTopValOnModalOpen();
                },
                onRemoving: function () {
                    $rootScope.retainPosOnModalClose();
                }
            }, _this.addingToCartDialog));
            _this.addToCart(item, quantity);
        };
        $scope.isTemporaryHeatSensitiveItem = isTemporaryHeatSensitiveItem();
        /*quantity dropdown*/
        $scope.currentIndex = null;
        $scope.closeThis = closeThis;
        $scope.back_search = back_search;
        $scope.setCurrentItem = setCurrentItem;
        function closeThis() {
            $scope.currentIndex = null;
        }
        function back_search() {
            $window.history.back();
        }
        function setCurrentItem(itemId) {
            if (itemId == $scope.currentIndex) {
                $scope.currentIndex = null;
            }
            else {
                $scope.currentIndex = itemId;
            }
        }
        $scope.disableCartBtn = function () {
            if (!$scope.purchaseQuantity) {
                return true;
            }
        };
        $scope.clearQuantity = function (purchaseNumber) {
            if (purchaseNumber) {
                _this.purchaseNumber = '';
            }
            else {
                $scope.purchaseQuantity = '';
            }
        };
        $scope.viewSimilarProducts = function () {
            $scope.ga.sendEvent('Customer', 'View Similar Products', 'Click View Similar Products on Search Results Page', 1);
            self.productService.gotoAlternateProduct = true;
            $location.path('/products/detail/' + self.config.attributeNamePath + '/' + self.config.productNamePath + '/' + self.config.productId + '/' + _this.selectedItem.itemCode); // self.config.items[$scope.selectItemNum].itemCode)
        };
        $scope.displayQuickView = function (ev) {
            $mdDialog.show({
                controller: quickViewController,
                controllerAs: 'vm',
                locals: {
                    productId: self.config.productId,
                    itemCode: self.selectedItem.itemCode,
                    parentItem: self.config.items,
                    currentDate: self.currentDate,
                    ga: self.$scope.ga,
                },
                template: require('./quickView.html'),
                parent: angular.element(document.querySelector('quick-view-overlay')),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                onShowing: function () {
                    $rootScope.saveTopValOnModalOpen();
                },
                onRemoving: function (event, removingFunctino) {
                    $rootScope.retainPosOnModalClose();
                }
            }).then(function (xClicked) {
                if (xClicked)
                    $scope.ga.sendEvent('Customer', 'Quick view usage', 'Close Quickview (x click)', 1);
            }, function () { $scope.ga.sendEvent('Customer', 'Quick view usage', 'Close Quickview (outside click)', 1); });
        };
        $scope.productCardMessage = function (val) {
            if (_this.selectedItem) {
                if (val === 'itemDiscontinued') {
                    return _this.selectedItem.isDiscontinued;
                }
                if (val === 'vendorBackOrder') {
                    if (_this.selectedItem.isDiscontinued) {
                        return false;
                    }
                    if (_this.selectedItemInventory && _this.selectedItemInventory.vendorBackOrder) {
                        return true;
                    }
                }
                if (val === 'stock') {
                    if ((_this.selectedItem.isDiscontinued) || (_this.selectedItemInventory && _this.selectedItemInventory.vendorBackOrder)) {
                        return false;
                    }
                    if (_this.stock <= 0) {
                        return true;
                    }
                }
            }
        };
    }
    ProductCardController.prototype.$onInit = function () {
        this.selectedItem = this.config.items[0];
        this.setSelectedItem();
        this.setInventoryData();
        this.checkForCondition();
    };
    ProductCardController.prototype.setSelectedItem = function () {
        var _this = this;
        if (!!this.itemCode) {
            var filteredList = this.config.items.filter(function (item) { return item.itemCode.toUpperCase() === _this.itemCode.toUpperCase(); });
            if (filteredList.length > 0) {
                this.selectedItem = filteredList[0];
            }
            return;
        }
        this.selectedItem = this.config.items.filter(function (item) { return item.inventory.some(function (inv) { return inv.stock > 0 && inv.isDefault; }); })[0];
    };
    ProductCardController.prototype.getStockInfo = function () {
        this.csaStockDialog = {
            template: "\n        <md-dialog class=\"csa-stock-info-dialog\">\n          <csa-stock-info-dialog warehouse-key=\"$ctrl.warehouseKey\"\n                                 item-id=\"{{$ctrl.itemCode}}\"\n                                 stock=\"{{$ctrl.stock}}\"></csa-stock-info-dialog>\n        </md-dialog>\n      ",
            locals: {
                warehouseKey: this.selectedItemInventory.warehouse,
                itemCode: this.selectedItem.itemCode,
                stock: this.selectedItemInventory.stock
            },
            controller: /** @class */ (function () {
                function StockInfoController(warehouseKey, itemCode, stock) {
                    'ngInject';
                    this.warehouseKey = warehouseKey;
                    this.itemCode = itemCode;
                    this.stock = stock;
                }
                return StockInfoController;
            }()),
            controllerAs: '$ctrl',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: false
        };
        this.$mdDialog.show(this.csaStockDialog);
    };
    ProductCardController.prototype.checkForCondition = function () {
        var isHeatSensitive = this.config.isHeatSensitive || (this.config.isTempHeatSensitive && this.$scope.isTemporaryHeatSensitiveItem);
        var isProp65Restriction2 = this.selectedItem.prop65Restriction === 2 && !this.selectedItem.prop65AlternativeItemId;
        var isProp65Restriction3 = this.selectedItem.prop65Restriction === 3 && !this.selectedItem.prop65AlternativeItemId;
        if (this.selectedItem.specialOrder ||
            (this.selectedItemInventory && this.selectedItemInventory.shortShelfLife) ||
            isHeatSensitive ||
            isProp65Restriction2 ||
            isProp65Restriction3) {
            this.hasCondition = true;
        }
        else {
            this.hasCondition = false;
        }
    };
    ProductCardController.prototype.disableCart = function () {
        if (this.selectedItem && this.selectedItem.isRestricted) {
            var brandAgreementsLink = '';
            if (this.selectedItem.restrictionCode === -15 && !!(this.rootScope.userInfo) && this.rootScope.userInfo.accountType === 'Practitioner') {
                brandAgreementsLink = '<br/><a href="/account/view-brand-agreements">Sign agreement through My Account.</a>';
            }
            this.disableCartPopupMessage = '<h3>Purchase Not Authorized</h3><p>' + this.selectedItem.restrictedMessage + brandAgreementsLink + '</p>';
            return true;
        }
        else if (this.selectedItemInventory && (this.selectedItemInventory.vendorBackOrder || this.selectedItem.isDiscontinued) && this.selectedItemInventory.stock <= 0) {
            this.disableCartPopupMessage = '<h3>Item out of stock</h3>';
            return true;
        }
        else {
            return false;
        }
    };
    ProductCardController.prototype.getDisableCartPopupMessage = function () {
        return this.disableCartPopupMessage;
    };
    ProductCardController.prototype.setInventoryData = function () {
        var _this = this;
        if (this.selectedItem.inventory && this.selectedItem.inventory.length) {
            var stocks_1 = [];
            this.selectedItem.inventory.forEach(function (arr) {
                _this.totalStock += arr.stock;
                stocks_1.push(arr.stock);
                if (arr.isDefault) {
                    _this.selectedItemInventory = arr;
                    _this.selectedItemInventory.stock = arr.stock > 0 ? arr.stock : 0;
                    _this.setWarehouseCode();
                    var currentDate = new Date();
                    var deliverDate = _this.$filter('date')(arr.expectedDeliverDate, 'MM/dd/yyyy');
                    var expectedDeliverDate = new Date(arr.expectedDeliverDate);
                    var isVendorBackOrder = _this.selectedItemInventory.vendorBackOrder;
                    if (expectedDeliverDate === null || expectedDeliverDate < currentDate || isVendorBackOrder) {
                        _this.outOfStockMessage = 'Out of Stock ';
                    }
                    else {
                        _this.expectedDeliverDate = deliverDate;
                        _this.outOfStockMessage = 'Back in Stock ' + deliverDate;
                    }
                }
            });
        }
        else {
            this.selectedItemInventory = this.selectedItem.inventory[0];
        }
    };
    ProductCardController.prototype.isQuantityValid = function (form, currentItem) {
        var self = this;
        var currentProd = currentItem.itemCode;
        var currentProdQty = parseInt(form[currentProd].$viewValue);
        if (isNaN(currentProdQty)) {
            this.$scope.purchaseQuantity = this.oldPurchaseQuantity;
        }
        else {
            this.oldPurchaseQuantity = currentProdQty;
            var defaultInventory = this.cart.getDefaultInventory(currentItem.inventory);
            var onHandQuantity = defaultInventory.stock;
            if ((defaultInventory && defaultInventory.vendorBackOrder) && this.$scope.purchaseQuantity > onHandQuantity) {
                this.$scope.purchaseQuantity = onHandQuantity;
            }
        }
        if (currentItem.mandatorySalesMultiple != 0) {
            if (currentProdQty % currentItem.mandatorySalesMultiple !== 0) {
                self.multipleOf = true;
                document.getElementsByName(currentProd).forEach(function (item) {
                    if (item != undefined) {
                        var calcQty = Math.ceil(currentProdQty / currentItem.mandatorySalesMultiple) * currentItem.mandatorySalesMultiple;
                        item.value = calcQty;
                        form[currentProd].$viewValue = calcQty;
                    }
                });
            }
            else {
                self.multipleOf = false;
            }
        }
    };
    ProductCardController.prototype.closeMultipleMsg = function () {
        this.multipleOf = false;
    };
    ProductCardController.prototype.showDetailpage = function () {
        sessionStorage.setItem('prevOffset', this.$window.pageYOffset);
    };
    ProductCardController.prototype.setWarehouseCode = function () {
        var _this = this;
        this.WarehouseService.getAllWarehouses().then(function (warehouses) {
            _this.warehouseCode = warehouses.find(function (warehouse) { return warehouse.id == _this.selectedItemInventory.warehouse; }).warehouseCode;
        });
    };
    return ProductCardController;
}());
export default ProductCardController;
//# sourceMappingURL=product-card.controller.js.map